import React from 'react'
import {
  TRY_AGAIN
} from 'AccountsConstants/language/trips'

const ErrorView = ({ message, error, clickHandler }) => {
  return (
    <div className="pos-abs w-100p">
      <div className="yellow-bg hazard-icon pt-4 pb-4 pl-15 border-bottom-grey">
        <h3 className="fs-15 pl-2 fw-700">
          {message}
        </h3>
        <p className="fs-13 p-2">
          {error}
        </p>
        <p
          className="fs-12 fw-700 bg-grey grey-on-hover ml-2 mt-2 bt bb ta-c w-80 pt-2 pb-2 bl br br1"
          onClick={clickHandler}
        >
          {TRY_AGAIN}
        </p>
      </div>
    </div>
  )
}

export default ErrorView
